import { z } from 'zod';
import { makeFieldSchemaFromZod } from '@backstage/plugin-scaffolder';

/**
 * @public
 */
export const entityQueryFilterExpressionSchema = z.record(
  z
    .string()
    .or(z.object({ exists: z.boolean().optional() }))
    .or(z.array(z.string())),
);

/**
 * @public
 */
export const CBEntityPickerFieldSchema = makeFieldSchemaFromZod(
  z.string(),
  z.object({
    allowedKinds: z
      .array(z.string())
      .optional()
      .describe(
        'DEPRECATED: Use `catalogFilter` instead. List of kinds of entities to derive options from',
      ),
    disabled: z
      .boolean()
      .optional()
      .describe('Whether to disable or not user input. Defaults to false'),
    catalogFilter: z
      .array(entityQueryFilterExpressionSchema)
      .or(entityQueryFilterExpressionSchema)
      .optional()
      .describe('List of key-value filter expression for entities'),
  }),
);

/**
 * The input props that can be specified under `ui:options` for the
 * `CBEntityPicker` field extension.
 *
 * @public
 */
export type CBEntityPickerUiOptions =
  typeof CBEntityPickerFieldSchema.uiOptionsType;

export type CBEntityPickerProps = typeof CBEntityPickerFieldSchema.type;

export const CBEntityPickerSchema = CBEntityPickerFieldSchema.schema;

export type CBEntityPickerFilterQuery = z.TypeOf<
  typeof entityQueryFilterExpressionSchema
>;

export type CBEntityPickerFilterQueryValue =
  CBEntityPickerFilterQuery[keyof CBEntityPickerFilterQuery];